module.exports = __webpack_public_path__ + "static/tiago-rosado-mwV6PsB-7Bk-unsplash-c4db99c6b758da1ac29fc9ddefffb0be.png";